import styled from 'styled-components';

export const RefundSelectMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
        border: solid 1px ${props.theme.colors.grey.lighte7}; 
    `
);

export const RefundSelectInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20};
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    `
);

export const RefundModeSelectWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `
);

export const RefundOptionSelectWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
    `
);

export const RefundOptionSelected = styled.div(
    props => `
        width: 1.8rem;
        height: 1.8rem;
        border-radius: ${props.theme.misc.borderRadius.round};
        border: 1px solid ${props.theme.colors.blue.base};
        position: relative;
        cursor: pointer;
        &:after{
            content: '';
            width:1.4rem;
            height: 1.4rem;
            background-color: ${props.theme.colors.blue.base};
            border-radius: ${props.theme.misc.borderRadius.round};
            position: absolute;
            top: 0.1rem;
            left: 0.1rem;
        }

    `
);

export const RefundOptionSelect = styled.div(
    props => `
        width: 1.8rem;
        height: 1.8rem;
        border-radius: ${props.theme.misc.borderRadius.round};
        border: 1px solid ${props.theme.colors.grey.light9b};
        position: relative;
        cursor: pointer;
    `
)

export const RefundModeHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-left: ${props.theme.spacing.base};
    `
);

export const RefundStateText = styled.p(
    props => `
        background-color: ${props.theme.colors.green.base};
        padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.base};
        border-radius: 1.4rem;
        dispaly: flex;
        margin-left: ${props.theme.spacing.base};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const RefundAmountText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-align: right;
    `
);

export const RefundDetailsInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.large.l20};
        padding-left: ${props.theme.spacing.large.l27};
    `
);

export const RefundMainInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const RefundSubInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        padding-top: ${props.theme.spacing.small.s5};
    `
);